/* Linky — chiude il pannello sconto del carrello dopo che un codice e' stato applicato.

   Il tema non espone Alpine su window, quindi non si puo' agire sullo store dall'esterno.
   Usiamo solo il DOM: clicchiamo la X del pannello, che il tema collega gia' a openField = false.

   Due percorsi coperti:
   1) applicazione o rimozione riuscita -> il tema dispatcha 'eurus:cart:discount-code:change'
   2) codice gia' applicato -> nessun evento, quindi intercettiamo il clic su Apply nel pannello

   Se compare il messaggio di errore il pannello resta aperto, cosi' l'utente puo' correggere. */
(function () {
  if (window.__linkyDiscountPanelAutoclose) return;
  window.__linkyDiscountPanelAutoclose = true;

  var DELAY = 1200;

  function isVisible(el) {
    return el && getComputedStyle(el).display !== 'none';
  }

  function closeDiscountPanel() {
    setTimeout(function () {
      try {
        var panels = document.querySelectorAll('[x-show*="discount_field"]');
        for (var i = 0; i < panels.length; i++) {
          var p = panels[i];
          if (!isVisible(p)) continue;
          var err = p.querySelector('[x-show*="discountFaild"], [x-show*="freeShippingApplied"]');
          if (isVisible(err)) return;
          var x = p.querySelector('.icon-close-container');
          if (x) { x.click(); return; }
        }
      } catch (e) {}
    }, DELAY);
  }

  document.addEventListener('eurus:cart:discount-code:change', closeDiscountPanel);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('[x-show*="discount_field"]')) return;
    if (!t.closest('button')) return;
    closeDiscountPanel();
  }, true);
})();
